import { useMemo, useState } from "react";

const useAuthorization = (roles) => {
  const [role, setRole] = useState(sessionStorage.getItem("role"));

  const userHasRequiredRole = useMemo(
    () => roles?.includes(role),
    [role, roles]
  );

  return {
    userHasRequiredRole,
  };
};

export default useAuthorization;
